import React, { memo } from 'react';

import { deprecate } from 'react-is-deprecated';

import PropTypes from 'prop-types';

import { formatNumber } from '@atc/string-fns';

import { Button, Heading, StarRating, SubHeading, Text } from 'reaxl';

import RatingBreakdown from '@/components/RatingsReviews/RatingBreakdown/RatingBreakdown';

function ConsumerRatings({
    heading,
    onReviewsDetailClick = () => { },
    overallRating,
    ratings,
    ratingBarsClassName, // deprecated
    ratingBreakdownClassName,
    reviewCounts,
    title,
    ...rest
}) {
    return (
        <div
            data-cmp="consumerRatings"
            {...rest}
        >
            {heading && (
                <Heading level={2}>
                    {heading}
                </Heading>
            )}
            {title && (
                <SubHeading level={3}>
                    {title}
                </SubHeading>
            )}
            <div className="display-flex align-items-center gap-3 margin-top-3">
                {overallRating && (
                    <Text
                        size={700}
                        weight="bold"
                    >
                        {overallRating.toFixed(1)}
                    </Text>
                )}
                <div className="line-height-sm">
                    <StarRating
                        value={overallRating}
                        color="#e8bb38"
                        className="text-size-500"
                    />
                    <Text
                        componentClass="div"
                        size={200}
                        weight="bold"
                    >
                        Consumer Rating
                        {reviewCounts && (
                            <>
                                {' '}
                                <Button
                                    className="text-normal"
                                    bsStyle="text"
                                    onClick={onReviewsDetailClick}
                                >
                                    {`(${formatNumber({ value: reviewCounts })} reviews)`}
                                </Button>
                            </>
                        )}
                    </Text>
                </div>
            </div>
            <RatingBreakdown
                className={ratingBarsClassName || ratingBreakdownClassName}
                ratings={ratings}
            />
        </div>
    );
}

ConsumerRatings.propTypes = {
    /**
     * Optional heading
     */
    heading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    /**
     * The callback function to handle reviews CTA
     */
    onReviewsDetailClick: PropTypes.func,
    /**
     * The overall rating value.
     */
    overallRating: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    /**
     * The ratings array in format { name, value }.
     */
    ratings: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    })),
    /**
     * The classes for RatingBreakdown container
     */
    ratingBarsClassName: deprecate(PropTypes.string, 'ratingBarsClassName is deprecated. Please use the ratingBreakdownClassName prop.'),
    /**
     * The classes for RatingBreakdown container
     */
    ratingBreakdownClassName: PropTypes.string,
    /**
     * The total number of reviews
     */
    reviewCounts: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    /**
     * Optional title
     */
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
};

export default memo(ConsumerRatings);
